import PopupTable from "./components/popupTable";
import PopupToolbar from "./components/PopupToolbar";

export default function PopupList() {
  return (
    <>
      <PopupToolbar />
      <PopupTable />
    </>
  );
}
